import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/common/Button';
import { AvailableTestsList } from '../components/student/AvailableTestsList';
import { TestHistory } from '../components/student/TestHistory';
import { testSetService } from '../services/testSetService';
import { attemptService } from '../services/attemptService';
import { TestSet, TestAttempt } from '../types/models';
import { authService } from '../services/authService';
import toast from 'react-hot-toast';
import { FullPageSpinner } from '../components/common/Spinner';

const pageStyle: React.CSSProperties = {
  maxWidth: '800px',
  margin: '0 auto',
  padding: '2rem',
};

export const StudentDashboard = () => {
  const { user } = useAuth();
  const [testSets, setTestSets] = useState<TestSet[]>([]);
  const [attempts, setAttempts] = useState<TestAttempt[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleLogout = async () => {
    await authService.logout();
    toast.success('Wylogowano pomyślnie.');
  };

  useEffect(() => {
    if (!user) return;

    const fetchData = async () => {
      try {
        const [sets, userAttempts] = await Promise.all([
          testSetService.getPublishedTestSets(), // ZMIANA TUTAJ
          attemptService.getAttemptsForUser(user.id)
        ]);
        setTestSets(sets);
        setAttempts(userAttempts);
      } catch (error) {
        console.error("Błąd podczas pobierania danych kursanta", error);
        toast.error("Nie udało się załadować danych.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [user]);

  return (
    <div style={pageStyle}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1>Panel Kursanta</h1>
          <h2>Witaj, {user?.firstName}!</h2>
        </div>
        <Button onClick={handleLogout} variant="secondary">Wyloguj</Button>
      </header>
      <main>
        {isLoading ? (
          <FullPageSpinner />
        ) : (
          <>
            <AvailableTestsList testSets={testSets} />
            <TestHistory attempts={attempts} />
          </>
        )}
      </main>
    </div>
  );
};